import dayjs from "dayjs";

function overlap(start, end, tz) {
  let el_start = dayjs(start).tz(tz).startOf('day');
  let el_end = dayjs(end).tz(tz).startOf('day');
  let diff = el_end.diff(el_start, 'day');

  const elements = [];

  if (diff !== 0) {
    for (let i = 0; i < diff; i++) {
      if (i === 0) {
        elements.push({
          start: start,
          end: dayjs(end).tz(tz).endOf('day').valueOf()
        });
      } else if (i !== 0 && i === diff - 1) {
        elements.push({
          start: dayjs(start).tz(tz).add(i, 'day').startOf('day').valueOf(),
          end: end
        });
      } else {
        elements.push({
          start: dayjs(start).tz(tz).add(i, 'day').startOf('day').valueOf(),
          end: dayjs(end).tz(tz).endOf('day').valueOf()
        });
      }
    }
  }

  return elements;
}

export function normalizeTrackingElements(rows, from, to, tz) {
  const elementsData = [];

  rows.forEach((row) => {
    // Only time-like events for now
    if (!row) return;

    const isTimerLike = row.element_type === 'track' || row.element_type === 'track_deep' || row.element_type === 'collector_track';
    if (!isTimerLike) return;

    const start = row.start_ts;
    const end = row.end_ts ?? Date.now();
    if (!start || !end) return;
    if (end < start) return;

    const baseElement = {
      id: row.element_id,
      start,
      end,
      color: row.block_color || 'gray',
      project: row.project_name || 'No project',
      projectColor: row.project_color || 'gray',
      title: row.block_title || 'Untitled',
      date: dayjs(start).tz(tz).format('YYYY-MM-DD'),
      duration: end - start,
    };

    const overlapElements = overlap(start, end, tz);
    if (overlapElements.length) {
      overlapElements.forEach((o) => {
        elementsData.push({
          ...baseElement,
          start: o.start,
          end: o.end,
          date: dayjs(o.start).tz(tz).format('YYYY-MM-DD'),
          duration: o.end - o.start,
        });
      });
    } else {
      elementsData.push(baseElement);
    }
  });

  // Optional range clamp
  if (from || to) {
    const fromTs = typeof from === 'number' ? from : (from ? Number(from) : null);
    const toTs = typeof to === 'number' ? to : (to ? Number(to) : null);

    return {
      elementsBlock: elementsData.filter((el) => {
        if (fromTs && el.end < fromTs) return false;
        if (toTs && el.start > toTs) return false;
        return true;
      }),
    };
  }

  return { elementsBlock: elementsData };
}
